export default "__VITE_ASSET__EF3mfkwg__"